import { makeGetRequest } from 'owa-ows-gateway';
import { GetUserPersistedFlightResponse } from './GetUserPersistedFlightResponse';

const GET_USERPERSISTED_FLIGHT_URL: string = 'ows/api/v1/PremiumFlight';
let getUserPersistedFlightPromise: Promise<GetUserPersistedFlightResponse>;

export function getUserPersistedFlight(): Promise<GetUserPersistedFlightResponse> {
    if (!getUserPersistedFlightPromise) {
        getUserPersistedFlightPromise = makeGetRequest(GET_USERPERSISTED_FLIGHT_URL);
    }
    return getUserPersistedFlightPromise;
}
